import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-[1180px]" }

import { onMounted } from 'vue'

import FranchiseDayBottleList from '@/components/franchise/FranchiseDayBottleList.vue'


export default {
  __name: 'FranchiseDayCarts',
  props: { day: { type: Object, required: true } },
  setup(__props) {

const props = __props

onMounted(() => props.day.loadCarts())

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FranchiseDayBottleList, {
      list: __props.day.carts,
      "location-name": __props.day.locationName,
      "empty-label": "unpaid carts",
      onPrev: _cache[0] || (_cache[0] = ret => __props.day.prevCarts().then(ret)),
      onNext: _cache[1] || (_cache[1] = ret => __props.day.nextCarts().then(ret))
    }, null, 8, ["list", "location-name"])
  ]))
}
}

}